<template>
  <table class="info-table table table-sm">
    <tr>
      <th class="border-top-0">{{$t('Old')}}</th>
      <th class="border-top-0">{{$t('New')}}</th>
    </tr>
    <tr>
      <td>
        <div :class="{'bottom-dashed': index < activity.old_data.length - 1}" class="charge-div"
             v-for="(charge, index) in activity.old_data" :key="`misc-charge-old-${index}`">
          <p class="mb-0"><b>{{$t('Title:')}}</b> {{charge.description}}</p>
          <p class="mb-0"><b>{{$t('Amount:')}}</b> {{charge.amount | asCurrency}}</p>
          <p class="mb-0"><b>{{$t('Taxable:')}}</b> {{charge.taxable ? $t('Yes') : $t('No')}}</p>
        </div>
        <div v-if="!activity.old_data || activity.old_data.length === 0">{{$t('N/A')}}</div>
      </td>
      <td>
        <div :class="{'bottom-dashed': index < activity.data.length - 1}" class="charge-div"
             v-for="(charge, index) in activity.data" :key="`misc-charge-old-${index}`">
          <p class="mb-0"><b>{{$t('Title:')}}</b> {{charge.description}}</p>
          <p class="mb-0"><b>{{$t('Amount:')}}</b> {{charge.amount | asCurrency}}</p>
          <p class="mb-0"><b>{{$t('Taxable:')}}</b> {{charge.taxable ? $t('Yes') : $t('No')}}</p>
        </div>
        <div v-if="!activity.data || activity.data.length === 0">{{$t('N/A')}}</div>
      </td>
    </tr>
  </table>
</template>

<script>
  export default {
    name: "ActivityMiscellaneousTable",
    props: {
      activity: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped lang="scss">
  .info-table {
    tr {
      td:first-child {
        border-right: 1px solid #cecece;
      }

      td {
        width: 50%;

        .charge-div {
          padding-top: 5px;
          padding-bottom: 5px;
        }
      }
    }
  }

  .bottom-dashed {
    border-bottom: 1px dashed #cecece
  }
</style>
